"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Calendar;
var _react = _interopRequireDefault(require("react"));
var _CalendarRow = _interopRequireDefault(require("./CalendarRow"));
var _CalendarLabels = _interopRequireDefault(require("./CalendarLabels"));
var _CalendarIncrementor = _interopRequireDefault(require("./CalendarIncrementor"));
var _CalendarLoading = _interopRequireDefault(require("./CalendarLoading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _Calendar_css = _interopRequireDefault(require("./Calendar_css"));
var _CalendarDay_css = _interopRequireDefault(require("./CalendarDay_css"));
var _locales = require("../../utils/locales");
var _Calendar = require("./Calendar.utils");
var _localeData = _interopRequireDefault(require("dayjs/plugin/localeData"));
var _dayjs = _interopRequireDefault(require("dayjs"));
require("dayjs/locale/es");
require("dayjs/locale/fr");
require("dayjs/locale/pt");
require("dayjs/locale/zh-cn");
require("dayjs/locale/tl-ph");
require("dayjs/locale/ja");
require("dayjs/locale/hi");
require("dayjs/locale/it");
require("dayjs/locale/de");
require("dayjs/locale/ko");
require("dayjs/locale/en");
// always include English last

_dayjs.default.extend(_localeData.default);
function Calendar(_ref) {
  let {
    themeColor = "primary",
    language = "en",
    ...props
  } = _ref;
  (0, _appendCss.default)("arc_cal", [_Calendar_css.default, _CalendarDay_css.default]);
  const localeValue = (0, _Calendar.getLocaleValue)(language);
  _dayjs.default.locale(localeValue);
  const labels = _dayjs.default.weekdaysShort();
  function getRowText(index, arrayLength) {
    if (index === 0) {
      return "first";
    } else if (index === arrayLength - 1) {
      return "last";
    }
    return "middle";
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `Calendar ${themeColor}-color t-body-small`,
    id: props.month[0][6].date.locale(localeValue).format("MMMM")
  }, props.numberOfCalendars < 12 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.showIndicators.prev && /*#__PURE__*/_react.default.createElement(_CalendarIncrementor.default, {
    numberOfCalendars: props.numberOfCalendars,
    calendarIndex: props.index,
    clickHandler: props.clickCalendarIncrementor,
    direction: "backward",
    language: language
  }), props.showIndicators.next && /*#__PURE__*/_react.default.createElement(_CalendarIncrementor.default, {
    numberOfCalendars: props.numberOfCalendars,
    calendarIndex: props.index,
    clickHandler: props.clickCalendarIncrementor,
    direction: "forward",
    language: language
  })) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "Calendar-name t-title-large"
  }, props.month[0][6].date.locale(localeValue).format("MMMM YYYY")), /*#__PURE__*/_react.default.createElement("div", {
    className: "Calendar-weekdays"
  }, /*#__PURE__*/_react.default.createElement(_CalendarLabels.default, {
    labels: labels,
    language: language
  }), props.isLoading && /*#__PURE__*/_react.default.createElement(_CalendarLoading.default, null), props.month.map((week, rowIndex, readOnlyArray) => /*#__PURE__*/_react.default.createElement(_CalendarRow.default, {
    clickSelectDate: props.clickSelectDate,
    key: `cal-row-${rowIndex}`,
    rowDays: week,
    row: getRowText(rowIndex, readOnlyArray.length),
    hoverSelectDate: props.hoverSelectDate,
    hoverOffDate: props.hoverOffDate,
    isLoading: props.isLoading,
    language: language
  }))));
}
Calendar.propTypes = {
  /** Function to handle calendar incrementor clicks */
  clickCalendarIncrementor: _propTypes.default.func.isRequired,
  /** Function to handle the click of a day */
  clickSelectDate: _propTypes.default.func.isRequired,
  /** Function to handle mouse out of a day */
  hoverOffDate: _propTypes.default.func.isRequired,
  /** Index of calendar when there are mulptiple */
  index: _propTypes.default.number.isRequired,
  /** Function to handle mouse over of a day */
  hoverSelectDate: _propTypes.default.func.isRequired,
  /** Latest day available, will auto-adjust to 20 days after start date in range */
  maxDate: _propTypes.default.object,
  /** Earliest day available */
  minDate: _propTypes.default.object,
  /** Array of calendar weeks in month */
  month: _propTypes.default.array.isRequired,
  /** Number of calendars simultaneously visible */
  numberOfCalendars: _propTypes.default.number.isRequired,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** Selected user Language */
  language: _propTypes.default.oneOf([_locales.locales.en, _locales.locales.es, _locales.locales.fr, _locales.locales.pt, _locales.locales.zh, _locales.locales.tl, _locales.locales.de, _locales.locales.it, _locales.locales.ko, _locales.locales.ja, _locales.locales.hi])
};